export default function Footer() {
  return (
    <footer className="footer">
      <p>© {new Date().getFullYear()} <span>Ejecta Landscapes</span>. All rights reserved.</p>
    </footer>
  );
}
